import React from 'react';
import { FaeKey } from '../../../../types';
import { capitalize } from '../../../../utils/capitalize';
import { getIconPath } from '../../../../utils/iconPath';
import { Check } from 'lucide-react';

export const FaeFilterIcon = React.memo(({ 
  fae, 
  isActive, 
  colors, 
  onToggle 
}: { 
  fae: FaeKey; 
  isActive: boolean; 
  colors: { hex: string }; 
  onToggle: (fae: FaeKey) => void; 
}) => {
  const iconPath = getIconPath('fae', fae);
  return (
    <td className="px-1">
      <div 
        onClick={() => onToggle(fae)} 
        className="relative group cursor-pointer"
        title={capitalize(fae)}
      >
        <div 
          className={`
            w-8 h-8 rounded-full overflow-hidden transition-all duration-200
            ${isActive
              ? `scale-110 z-10 border-2 shadow-[0_0_10px_rgba(0,0,0,0.5)]`
              : `border border-slate-600 opacity-60 hover:opacity-100 hover:scale-105`
            }
          `}
          style={isActive ? { borderColor: colors.hex, backgroundColor: colors.hex } : {}}
        >
          <img 
            src={iconPath} 
            alt={fae} 
            className="w-full h-full object-cover"
            height="32px"
            width="32px"
          />
          {/* Checkmark Overlay */}
          {isActive && (
            <div className="absolute inset-0 flex items-center justify-center bg-black/30 backdrop-blur-[1px]">
              <Check className="w-4 h-4 text-green-400 drop-shadow-md" strokeWidth={3} />
            </div>
          )}
        </div>
      </div>
    </td>
  );
});
